/** @jsxRuntime classic */

/**
 * A component to contain all the exhibitor details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {string} props.eventId The event id.
 * @returns
 */
export default function ExhibitorContacts({ exhibitor, eventId, ...rest }) {
  return null;
}
